(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('qs-config')?.textContent || '{}');
  const strings = config.strings || {};
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat(config.locale || 'pt-BR', {style:'currency',currency:config.currency || 'BRL'}).format(Number(value) / 100);
  const text = key => strings[key] || key;
  const cartDialog = () => document.getElementById('qs-cart');
  let cartBusy = false;
  const setCartMessage = message => { const target = document.querySelector('[data-qs-cart-message]'); if (target) target.textContent = message || ''; };
  async function request(path, body) {
    const response = await fetch(root + path, {method:body ? 'POST' : 'GET',headers:body ? {'Content-Type':'application/json','Accept':'application/json'} : {'Accept':'application/json'},body:body ? JSON.stringify(body) : undefined});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || text('request_error'));
    return result;
  }
  async function refreshCart(open = false) {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id','qs-cart');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw new Error(text('cart_refresh_error'));
    const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
    const content = parsed.querySelector('[data-qs-cart-content]');
    const current = cartDialog()?.querySelector('[data-qs-cart-content]');
    if (!content || !current) throw new Error(text('cart_refresh_error'));
    current.replaceWith(content);
    document.querySelectorAll('[data-qs-cart-count]').forEach(node => {node.textContent = content.dataset.count;});
    if (open && !cartDialog().open) cartDialog().showModal();
    document.dispatchEvent(new CustomEvent('qs:cart-updated'));
  }
  async function changeLine(line, quantity) {
    if (cartBusy || !line) return;
    cartBusy = true;
    cartDialog().setAttribute('aria-busy','true');
    setCartMessage('');
    try {
      await request('cart/change.js',{id:line.dataset.lineKey,quantity:Math.max(0,Math.floor(Number(quantity) || 0))});
      await refreshCart();
    } catch (error) {
      setCartMessage(error.message);
      try { await refreshCart(); } catch (_) { setCartMessage(text('cart_refresh_error')); }
    } finally {
      cartBusy = false;
      cartDialog().removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-qs-cart-open]');
    if (open && cartDialog()) {
      event.preventDefault();
      if (!cartDialog().open) cartDialog().showModal();
      try { await refreshCart(); } catch (error) { setCartMessage(error.message); }
      return;
    }
    if (event.target.closest('[data-qs-cart-close]')) { cartDialog()?.close(); return; }
    const remove = event.target.closest('[data-qs-cart-remove]');
    if (remove) { await changeLine(remove.closest('[data-line-key]'),0); return; }
    const step = event.target.closest('[data-qs-cart-step]');
    if (step) {
      const line = step.closest('[data-line-key]');
      await changeLine(line,Number(line.querySelector('input').value) + Number(step.dataset.qsCartStep));
      return;
    }
    const quickAdd = event.target.closest('[data-qs-quick-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      setCartMessage('');
      let added = false;
      try { await request('cart/add.js',{items:[{id:Number(quickAdd.dataset.qsQuickAdd),quantity:1}]}); added = true; await refreshCart(true); }
      catch (error) {setCartMessage(added ? text('added_refresh_error') : error.message);quickAdd.disabled = added;}
      return;
    }
    const anchor = event.target.closest('a[href^="#qs-ingredients-"]');
    if (anchor) { const target = document.querySelector(anchor.getAttribute('href')); const details = target?.querySelector('details'); if (details) details.open = true; }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-qs-cart-quantity]')) changeLine(event.target.closest('[data-line-key]'),event.target.value);
  });
  cartDialog()?.addEventListener('click', event => { if (event.target === cartDialog()) {const rect = cartDialog().getBoundingClientRect();if (event.clientX < rect.left || event.clientX > rect.right) cartDialog().close();} });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-qs-discount-form]');
    if (!form) return;
    event.preventDefault();
    const code = form.elements.discount.value.trim();
    if (!code) return;
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const cart = await request('cart/update.js',{discount:code});
      await refreshCart();
      const discount = cart.discount_codes?.find(item => item.code.toLowerCase() === code.toLowerCase());
      const applied = discount?.applicable || cart.cart_level_discount_applications?.some(item => item.title.toLowerCase() === code.toLowerCase()) || cart.items?.some(item => item.discount_allocations?.some(allocation => allocation.discount_application?.title?.toLowerCase() === code.toLowerCase()));
      setCartMessage(applied ? text('coupon_applied') : text('coupon_unavailable'));
    } catch (error) {setCartMessage(error.message);button.disabled = false;}
  });
  function initProduct(section) {
    if (section.dataset.qsReady) return;
    section.dataset.qsReady = 'true';
    const data = JSON.parse(section.querySelector('[data-qs-product-data]').textContent);
    const form = section.querySelector('[data-qs-product-form]');
    const variantInput = form.querySelector('[data-qs-variant]');
    const planInput = form.querySelector('[data-qs-plan-input]');
    const picker = form.querySelector('[data-qs-plan-picker]');
    const subscribe = form.querySelector('[name="qs_frequency"][value="subscribe"]');
    const once = form.querySelector('[name="qs_frequency"][value="once"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-qs-add]');
    const message = form.querySelector('[data-qs-product-message]');
    const sticky = section.querySelector('[data-qs-sticky]');
    let variant = data.variants.find(v => String(v.id) === variantInput.value) || data.variants[0];
    let busy = false;
    const initialPlan = new URLSearchParams(location.search).get('selling_plan');
    function renderPlans(selectedPlan) {
      const days = plan => Number(plan.name.match(/(15|30|45)\s*dias?/i)?.[1] || 0);
      const plans = [...variant.plans].sort((a,b) => days(a)-days(b));
      picker.replaceChildren(...plans.map(plan => { const option=document.createElement('option');option.value=plan.id;option.textContent=days(plan) ? 'A cada '+days(plan)+' dias' : plan.name;return option;}));
      const chosen = plans.find(plan => String(plan.id) === String(selectedPlan)) || plans.find(plan => days(plan) === 30) || plans[0];
      if (chosen) picker.value = String(chosen.id);
      form.querySelector('[data-qs-subscription]').hidden = !variant.plans.length;
      if (!variant.plans.length && once) once.checked = true;
    }
    function update() {
      const plan = variant.plans.find(p => String(p.id) === picker.value);
      const subscribed = !!(subscribe.checked && plan);
      const price = subscribed ? plan.price : variant.price;
      const quantity = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
      quantityInput.value = quantity;
      planInput.disabled = !subscribed;
      planInput.value = subscribed ? plan.id : '';
      section.querySelector('[data-qs-price]').textContent = money(price);
      section.querySelector('[data-qs-unit-price]').textContent = money(Math.round(price / Number(section.dataset.unitCount))) + ' ' + text('per_unit');
      section.querySelector('[data-qs-once-price]')?.replaceChildren(document.createTextNode(money(variant.price)));
      if (plan) {
        section.querySelector('[data-qs-sub-price]').textContent=money(plan.price);
        section.querySelector('[data-qs-compare]').textContent=money(variant.price);
        const discount=Math.round((1-plan.price/variant.price)*100);
        const badge=section.querySelector('[data-qs-discount]');
        badge.textContent=discount+'% OFF'; badge.hidden=discount<=0;
      }
      const unavailable = !variant.available || (data.requiresPlan && !subscribed);
      add.disabled = unavailable || busy;
      add.textContent = busy ? text('adding') : unavailable ? text('sold_out') : money(price*quantity)+' · '+text('add');
      if (sticky) {
        sticky.querySelector('[data-qs-sticky-price]').textContent=money(price*quantity);
        sticky.querySelector('button').disabled = unavailable || busy;
        sticky.querySelector('button').textContent = unavailable ? text('sold_out') : text('add');
      }
      section.querySelectorAll('[data-qs-keep-plan]').forEach(link => {const url=new URL(link.href);if(subscribed)url.searchParams.set('selling_plan',plan.id);else url.searchParams.delete('selling_plan');link.href=url;});
      const url=new URL(location.href);
      if(subscribed)url.searchParams.set('selling_plan',plan.id);else url.searchParams.delete('selling_plan');
      if(data.variants.length>1)url.searchParams.set('variant',variant.id);
      history.replaceState(null,'',url);
    }
    renderPlans(initialPlan);
    if (initialPlan && variant.plans.some(p => String(p.id) === initialPlan)) subscribe.checked = true;
    if (data.requiresPlan && variant.plans.length) subscribe.checked = true;
    update();
    form.addEventListener('change',event => {
      if(event.target === variantInput){variant=data.variants.find(v=>String(v.id)===variantInput.value);renderPlans(picker.value);}
      if(event.target === picker) subscribe.checked=true;
      update();
    });
    form.addEventListener('click',event => {const step=event.target.closest('[data-qs-step]');if(step){quantityInput.value=Math.max(1,Number(quantityInput.value)+Number(step.dataset.qsStep));update();}});
    form.addEventListener('submit',async event => {
      event.preventDefault();
      if(busy || add.disabled)return;
      busy=true;message.textContent='';update();
      const item={id:Number(variantInput.value),quantity:Number(quantityInput.value)};
      if(!planInput.disabled)item.selling_plan=Number(planInput.value);
      let added = false;
      try {await request('cart/add.js',{items:[item]});added = true;await refreshCart(true);}
      catch(error){message.textContent=added ? text('added_refresh_error') : error.message;}
      finally{busy=false;update();}
    });
    if(sticky && 'IntersectionObserver' in window){new IntersectionObserver(entries=>{const rect=entries[0].boundingClientRect;sticky.hidden=entries[0].isIntersecting||rect.top>0;},{threshold:0}).observe(form.querySelector('.qs-add-row'));}
  }
  function initGalleries(scope = document) {
    scope.querySelectorAll('[data-qs-gallery]').forEach(gallery=>{
      if(gallery.dataset.qsReady)return;gallery.dataset.qsReady='true';
      gallery.addEventListener('click',event=>{const button=event.target.closest('[data-qs-media-target]');if(!button)return;gallery.querySelectorAll('[data-qs-media]').forEach(panel=>{panel.hidden=panel.dataset.qsMedia!==button.dataset.qsMediaTarget;if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());});gallery.querySelectorAll('[data-qs-media-target]').forEach(target=>target.setAttribute('aria-pressed',String(target===button)));});
    });
  }
  function initCarousels(scope = document) {
    scope.querySelectorAll('[data-qs-carousel]').forEach(carousel=>{
      if(carousel.dataset.qsReady)return;carousel.dataset.qsReady='true';
      const slides=Array.from(carousel.querySelectorAll('[data-qs-slide]'));let active=0;let startX=0;
      function show(index){active=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==active;if(slide.hidden)slide.querySelectorAll('video').forEach(video=>video.pause());});carousel.querySelectorAll('[data-qs-slide-index]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.qsSlideIndex)===active)));}
      carousel.addEventListener('click',event=>{const step=event.target.closest('[data-qs-slide-step]');const dot=event.target.closest('[data-qs-slide-index]');if(step)show(active+Number(step.dataset.qsSlideStep));if(dot)show(Number(dot.dataset.qsSlideIndex));});
      carousel.addEventListener('touchstart',event=>{startX=event.touches[0].clientX;},{passive:true});
      carousel.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-startX;if(Math.abs(delta)>60)show(active+(delta<0?1:-1));},{passive:true});
    });
  }
  function initTabs(scope = document) {
    scope.querySelectorAll('[data-qs-tabs]').forEach(wrapper=>{
      if(wrapper.dataset.qsReady)return;wrapper.dataset.qsReady='true';
      const tabs=Array.from(wrapper.querySelectorAll('[data-qs-tab]'));
      function activate(tab,focus=false){tabs.forEach(button=>{button.setAttribute('aria-selected',String(button===tab));button.tabIndex=button===tab?0:-1;});wrapper.querySelectorAll('[data-qs-tab-panel]').forEach(panel=>panel.hidden=panel.dataset.qsTabPanel!==tab.dataset.qsTab);if(focus)tab.focus();}
      wrapper.addEventListener('click',event=>{const tab=event.target.closest('[data-qs-tab]');if(tab)activate(tab);});
      wrapper.addEventListener('keydown',event=>{if(!event.target.matches('[data-qs-tab]'))return;const index=tabs.indexOf(event.target);if(event.key==='ArrowRight'){event.preventDefault();activate(tabs[(index+1)%tabs.length],true);}if(event.key==='ArrowLeft'){event.preventDefault();activate(tabs[(index-1+tabs.length)%tabs.length],true);}});
    });
  }
  function init(scope=document){scope.querySelectorAll('[data-qs-product]').forEach(initProduct);initGalleries(scope);initCarousels(scope);initTabs(scope);}
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
